import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const Wrapper = styled.div<{ $xl?: boolean }>`
  background-color: var(--swatch3);
  color: var(--swatch2);
  padding: ${(props) => `${props.theme.spacing.m} 0 ${props.theme.spacing.l}`};

  .rich-text {
    margin-bottom: ${(props) => props.theme.spacing.m};

    > *:first-child {
      margin-top: 0;
    }
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => `${props.theme.spacing.l} 0`};

    .rich-text {
      margin-bottom: ${(props) => props.theme.spacing.l};
    }
  }

  ${(props) =>
    props.$xl &&
    css`
      @media (min-width: ${mobileBreakPointCSS}) {
        padding: ${(props) => `${props.theme.spacing.xl} 0`};
      }
    `}
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
    gap: ${(props) => props.theme.spacing.xl};
  }
`;

export const Filter = styled.div<{ $showOnMobile?: boolean }>`
  width: 204px;

  h2 {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    display: ${(props) => (props.$showOnMobile ? "block" : "none")};
    list-style: none;
    margin: ${(props) => props.theme.spacing.s} 0 0;
    padding: 0;
  }

  li {
    margin-bottom: ${(props) => props.theme.spacing.xs};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    ul {
      display: block;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing.m};
  gap: ${(props) => props.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${(props) => props.theme.spacing.l};
  }
`;

export const LoadMore = styled.div`
  margin-top: ${(props) => props.theme.spacing.m};
`;
